
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_rwraj_44",
  "outline": "awsui_outline_4yi2u_rwraj_77",
  "toggle-control": "awsui_toggle-control_4yi2u_rwraj_99",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_rwraj_119",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_rwraj_122",
  "toggle-control-readonly": "awsui_toggle-control-readonly_4yi2u_rwraj_128",
  "toggle-handle": "awsui_toggle-handle_4yi2u_rwraj_137",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_rwraj_162",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_rwraj_169",
  "toggle-handle-readonly": "awsui_toggle-handle-readonly_4yi2u_rwraj_173",
  "awsui-toggle-tail-off": "awsui_awsui-toggle-tail-off_4yi2u_rwraj_1",
  "awsui-toggle-tail-on": "awsui_awsui-toggle-tail-on_4yi2u_rwraj_1"
};
  